export default __webpack_public_path__ + "static/media/streamer_avatar18.6e6d334f.png";